import { Button } from '@/design-system/atoms/Button';
import { RichTextEditor } from '@/design-system/atoms/RichTextEditor';
import styles from '@/design-system/molecules/OnlineScheduling/OnlineScheduling.module.scss';

const TabButton = (props) => {
    const { cta, title } = props;
    return (
        cta &&
        cta?.href &&
        cta?.label && (
            <Button
                className={styles[`online-scheduling__cta`]}
                {...cta}
                buttonStyle={Button.STYLE.SECONDARY}
                analytics={{
                    componentName: 'fad_bio_scheduling_widget',
                    componentTitle: title,
                    interactionType: 'fad_bio_cta',
                }}
            />
        )
    );
};

const TabBody = (props) => {
    const { body } = props;
    return body && <RichTextEditor className={styles[`online-scheduling__body`]} text={body} />;
};

/**
 * Online Scheduling Tab Content Component
 * @returns { ReactDOM }
 */
export const OnlineSchedulingTabContent = (props) => {
    const {
        isNewPatient,
        tabBody,
        acceptingNewPatients,
        containerId,
        cta,
        available,
        noAvailabilityText,
    } = props;

    // Show no availability text when: new patient, accepting patients, but no availability
    const showNoAvailabilityMessage =
        isNewPatient && acceptingNewPatients && !available && noAvailabilityText;

    return (
        <div className={styles[`online-scheduling__content`]}>
            {showNoAvailabilityMessage ? (
                <RichTextEditor
                    className={styles[`online-scheduling__no-availability`]}
                    text={noAvailabilityText}
                />
            ) : (
                <>
                    <TabBody body={tabBody} />
                    {isNewPatient ? (
                        acceptingNewPatients && (
                            <div className={styles[`online-scheduling__iframe`]} id={containerId} />
                        )
                    ) : (
                        <TabButton cta={cta} />
                    )}
                </>
            )}
        </div>
    );
};
